import * as Core from '@skylab-shared/core';
import { RoleRelativeToOtherSeller } from './role-relative-to-other-seller';

export class HistoricalEntityModel extends Core.ModelBase {
    @Core.Property()
    @Core.NormalString('data-model.historical-entity.validation.city.length')
    public city: string;

    @Core.Property()
    public countryId: number;

    @Core.Property()
    @Core.VeryLongString('data-model.historical-entity.validation.address.length')
    public address: string;

    @Core.Property()
    public issueDocumentsToOtherSeller: boolean;

    @Core.Property({nullable: true})
    public roleRelativeToOtherSeller: RoleRelativeToOtherSeller;

    @Core.Property()
    @Core.VeryShortString('data-model.historical-entity.validation.zip-code.length')
    public zipCode: string;

    @Core.Property()
    @Core.VeryLongString('data-model.historical-entity.validation.name.length')
    public name: string;

    @Core.Property()
    @Core.VeryShortString('data-model.historical-entity.validation.tin.length')
    public tin: string;

    public get normalizedTin(): string {
        return this.tin.replace(/[\s\-]+/g, '');
    }
}
